/* Alert type filter: takes appends 'alert-' to the start of the passed in alert type, then formats it for ng-class with an optional second parameter
 *
 * Angular Module: "trackerbase-app.filters.alert-type-filter"
 * Filter exposed as: tbAlertType
 */

import angular from "angular";

function formatAlertTypeNameFilter(alertTypeShortName, enableType) {
    if ((alertTypeShortName != null) && (angular.isString(alertTypeShortName))) {

        let shouldEnable = (!!enableType);
        let result = {};
        result[`alert-${alertTypeShortName}`] = shouldEnable;
        return result;
    }
    else {
        return alertTypeShortName;
    }
}

function formatAlertTypeNameFilterFactory() {
    return formatAlertTypeNameFilter;
}

export default angular
    .module("trackerbase-app.filters.alert-type-filter", [])
    .filter("tbAlertType", formatAlertTypeNameFilterFactory)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/filters/AlertTypeFilter.js
// module id = /A1n
// module chunks = 1